import styled from 'styled-components';

export const AppWrapper = styled.div`
`;
